<template>
  <div class="loader-general" v-if="loader">
    <div class="loader-circle"></div>
  </div>
</template>

<script>

  import {mapState} from 'vuex'

  export default {
    name: "Loader",
    computed: {
      ...mapState({
        loader: state => state.loader
      })
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Partials/Loader.vue